// Firm screens (rail group "Firm"): route → page. Each reads the firm read models it needs (firm_models) and acts through the
// catalogue (firm-scope inbox rows); partner-only models and acts are explained to other roles, never hidden silently.
import type { ComponentType } from "react";
import { ChecksPage } from "./Checks";
import { FrontOfficePage } from "./FrontOffice";
import { HealingPage } from "./Healing";
import { LearningPage } from "./Learning";
import { QualityPage } from "./Quality";
import { RegistersPage } from "./Registers";
import { ResearcherPage } from "./Researcher";
import { TimePage } from "./Time";

export const FIRM_PAGES: Array<{ path: string; Page: ComponentType }> = [
  { path: "/firm/registers", Page: RegistersPage },
  { path: "/firm/quality", Page: QualityPage },
  { path: "/firm/front-office", Page: FrontOfficePage },
  { path: "/firm/checks", Page: ChecksPage },
  { path: "/firm/healing", Page: HealingPage },
  { path: "/firm/researcher", Page: ResearcherPage },
  { path: "/firm/learning", Page: LearningPage },
  { path: "/firm/time", Page: TimePage },
];
